<template>
    <el-button :type="type" v-bind="$attrs" v-on="$listeners" :icon="icon">
        保存
    </el-button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'primary'
        },
      icon: {
          type: String,
          default: 'fa fa-fw fa-save'
      }
    },
    methods: {
    }
}
</script>
